<!-- 网站首页 -->
<template>
  <div class="page_content bg_000000 ">
    <!-- Swiper -->
    <div v-if="type==='pc'" id='swiper-container_pc' class="swiper-container bg_000000">
      <transition name="el-fade-in">
        <img v-show="tabbar_idx<swiper_pc.length" id="home_shubiao" @click="click_next" class="home_shubiao p_hand"
          src="@/assets/images/home/home_shubiao.png" alt="" />
      </transition>
      <div v-show="isshow" class="swiper-wrapper">
        <div @click="link_to(item)" :class="item.banner_type==='链接'?'p_hand':''" class="swiper-slide swiper_content"
          :style="{ backgroundImage: `url(${item.img_url})` }" v-for="(item, index) in swiper_pc" :key='item.banner_id'>
          <!-- 预售状态 -->
          <div v-if="item.banner_type !== '链接' && item.productorInfoModel" class="tabbar_content">
            <div class="tabbar_content_name color_ffffff font_72 font_misans font_bold">
              {{ get_productName(item.productorInfoModel) }}
              <public-statuscard :sellStatusID='item.productorInfoModel.sellStatusID'></public-statuscard>
            </div>
            <!-- tags -->
            <div v-if="get_tags(item.productorInfoModel)" class="goods_tags color_ffffff">
              <span v-for="(item2, index2) in get_tags(item.productorInfoModel)" :key="index2"
                class="goods_tags_item border_radius18 font_15 font_500">{{ item2 }}</span>
            </div>
            <!-- btn -->
            <div class="btn_group">
              <div @click="$router.push(`/productInfo/${item.productorInfoModel.productId}`)"
                class="btn_item bg_ffffff color_DC000C font_24 font_800 p_text_center p_hand">
                {{ $t('goods.knowmore') }}
              </div>
              <!-- <a v-if="item.productorInfoModel.sellStatusID === 2 || item.productorInfoModel.sellStatusID === 3"
                :href="item.productorInfoModel.taobaoLink" target="_blank"
                class="btn_item a_biao bg_DC000C color_ffffff font_24 font_800 p_text_center p_hand">
                {{ $t('goods.buybtn') }}
              </a> -->
            </div>
          </div>
          <div v-if="item.banner_type !== '链接' && item.productorPreInfoModel" class="tabbar_content">
            <div class="tabbar_content_name color_ffffff font_72 font_misans font_bold">
              {{ get_productName(item.productorPreInfoModel) }}
              <public-statuscard :sellStatusID='item.productorPreInfoModel.sellStatusID'></public-statuscard>
            </div>
            <!-- tags -->
            <div v-if="get_tags(item.productorPreInfoModel)" class="goods_tags color_ffffff">
              <span v-for="(item2, index2) in get_tags(item.productorPreInfoModel)" :key="index2"
                class="goods_tags_item border_radius18 font_15 font_500">{{ item2 }}</span>
            </div>
            <!-- btn -->
            <div class="btn_group">
              <div @click="$router.push(`/peripheralInfo/${item.productorPreInfoModel.productId}`)"
                class="btn_item bg_ffffff color_DC000C font_24 font_800 p_text_center p_hand">
                {{ $t('goods.knowmore') }}
              </div>
              <!-- <a v-if="item.productorPreInfoModel.sellStatusID === 2 || item.productorPreInfoModel.sellStatusID === 3"
                :href="item.productorPreInfoModel.taobaoLink" target="_blank"
                class="btn_item a_biao bg_DC000C color_ffffff font_24 font_800 p_text_center p_hand">
                {{ $t('goods.buybtn') }}
              </a> -->
            </div>
          </div>
        </div>
        <!-- footer -->
        <div class="swiper-slide">
          <slot name="footer_pc"></slot>
        </div>
      </div>
    </div>
    <!-- pc -->
    <div v-if="type==='pc'" class="content_right p_flex p_column">
      <div v-for="(item, index) in swiper_pc" @click="click_tabbar(index, item.banner_id)"
        :class="tabbar_idx === index ? 'check_style' : ''"
        class="content_right_item p_flex p_row_reverse p_align_items p_hand">
        <span :class="tabbar_idx === index ? 'check_dot' : ''" class="content_right_dot"></span>
        {{get_tabbarname(item)}}
      </div>
    </div>
    <!-- h5 -->
    <transition name="el-fade-in">
      <div v-if="tabbar_idx<swiper_h5.length&&type==='h5'" class="content_right_h5 p_flex p_column">
        <div v-for="(item, index) in swiper_h5" @click="click_tabbar(index, item.banner_id)"
          :class="tabbar_idx === index ? 'check_style_h5' : ''"
          class="content_right_item_h5 p_flex p_row_reverse p_align_items p_hand">
          <span :class="tabbar_idx === index ? 'check_dot_h5' : ''" class="content_right_dot_h5"></span>
          {{get_tabbarname(item)}}
        </div>
      </div>
    </transition>
    <!-- h5 -->
    <div v-if="type==='h5'" id="swiper-container_h5" style="height: 100vh;">
      <van-swipe @change="h5swiper_change" ref="swiper_h5" :loop='false' vertical>
        <van-swipe-item @click="link_to(item)" :class="item.banner_type==='链接'?'p_hand':''" class="swiper_content_h5"
          :style="{ backgroundImage: `url(${item.img_url})` }" v-for="(item, index) in swiper_h5" :key="item.banner_id">
          <!-- 主线产品 -->
          <div v-if="item.banner_type !== '链接' && item.productorInfoModel" class="tabbar_content_h5 p_text_center">
            <public-statuscard style="display: block;" type='h5'
              :sellStatusID='item.productorInfoModel.sellStatusID'></public-statuscard>
            <div class="tabbar_content_name color_ffffff font_30 font_misans font_bold p_text_center">
              {{ get_productName(item.productorInfoModel) }}
            </div>
            <!-- tags -->
            <div v-if="get_tags(item.productorInfoModel)" class="goods_tags_h5 p_flex p_justify_center p_flex_wrap color_ffffff">
              <span v-for="(item1, index1) in get_tags(item.productorInfoModel)" :key="index1"
                class="goods_tags_item_h5 border_radius12 font_12 font_500">{{ item1 }}</span>
            </div>
            <!-- btn -->
            <div class="btn_group_h5 p_flex p_flex_wrap p_justify_center">
              <div @click="$router.push(`/productInfo/${item.productorInfoModel.productId}`)"
                class="btn_item_h5 bg_ffffff color_DC000C font_12 font_800 p_text_center p_hand">
                {{ $t('goods.knowmore') }}
              </div>
              <!-- <a v-if="item.productorInfoModel.sellStatusID === 2 || item.productorInfoModel.sellStatusID === 3"
                :href="item.productorInfoModel.taobaoLink" target="_blank"
                class="btn_item_h5 a_biao bg_DC000C color_ffffff font_12 font_800 p_text_center p_hand">{{ $t('goods.buybtn') }}</a> -->
            </div>
          </div>
          <!-- 周边产品 -->
          <div v-if="item.banner_type !== '链接' && item.productorPreInfoModel" class="tabbar_content_h5 p_text_center">
            <public-statuscard style="display: block;" type='h5'
              :sellStatusID='item.productorPreInfoModel.sellStatusID'></public-statuscard>
            <div class="tabbar_content_name color_ffffff font_30 font_misans font_bold p_text_center">
              {{ get_productName(item.productorPreInfoModel) }}
            </div>
            <!-- tags -->
            <div v-if="get_tags(item.productorPreInfoModel)" class="goods_tags_h5 p_flex p_justify_center p_flex_wrap color_ffffff">
              <span v-for="(item1, index1) in get_tags(item.productorPreInfoModel)" :key="index1"
                class="goods_tags_item_h5 border_radius12 font_12 font_500">{{ item1 }}</span>
            </div>
            <!-- btn -->
            <div class="btn_group_h5 p_flex p_flex_wrap p_justify_center">
              <div @click="$router.push(`/productInfo/${item.productorPreInfoModel.productId}`)"
                class="btn_item_h5 bg_ffffff color_DC000C font_12 font_800 p_text_center p_hand">
                {{ $t('goods.knowmore') }}
              </div>
              <!-- <a v-if="item.productorPreInfoModel.sellStatusID === 2 || item.productorPreInfoModel.sellStatusID === 3"
                :href="item.productorPreInfoModel.taobaoLink" target="_blank"
                class="btn_item_h5 a_biao bg_DC000C color_ffffff font_12 font_800 p_text_center p_hand">{{ $t('goods.buybtn') }}</a> -->
            </div>
          </div>
          <!--  -->
        </van-swipe-item>
        <!-- footer -->
        <van-swipe-item v-show="isshow" class="swiper_content_h5">
          <slot name="footer_h5"></slot>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex';
  import {
    swiper_list
  } from '@/network/index.js';
  import {
    window_open
  } from '@/utils/utils.js'
  var Vm;
  export default {
    data() {
      return {
        // availHeight: screen.availHeight,
        isshow: false,
        // swiper_list: [],
        tabbar_idx: 0,
        // dingwen: [],
        // screenWidth: '', //屏幕宽度
        timer: null,
        swiper: null, //swiper实例
      };
    },
    props: {
      type: {
        type: String,
        default: 'pc'
      },
      swiper_list:{
        type: Array,
        default: ()=>{
          return []
        }
      }
    },
    created() {
      Vm = this;
      let that = this;
      that.timer = setInterval(() => {
        if (document.readyState === 'complete') {
          if (that.type === 'pc') {
            that.swiper = new Swiper('#swiper-container_pc', {
              effect: 'slide',
              pagination: '.swiper-pagination',
              direction: 'vertical',
              loop: false,
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              slidesPerView: 1,
              paginationClickable: true,
              spaceBetween: 30,
              mousewheelControl: true,
              onSlideChangeEnd: function(swiper) {
                that.tabbar_idx = swiper.activeIndex
              }
            });
          }

          that.isshow = true;
          window.clearInterval(that.timer);
        }
      }, 500);
    },
    watch: {
      GET_LANG(nv, ov) {
        if(this.tabbar_idx!==0){
          this.click_tabbar(0)
        }
      }
    },
    destroyed() {},
    computed: {
      ...mapGetters('setting', ['GET_LANG', 'GET_LANG2']),
      swiper_pc() {
        if (this.swiper_list) {
          return this.shuju_shaixuan(this.swiper_list, 'PC', this.GET_LANG)
        }
      },
      swiper_h5() {
        if (this.swiper_list) {
          return this.shuju_shaixuan(this.swiper_list, '移动端', this.GET_LANG)
        }
      }
    },
    methods: {
      link_to(item) { //轮播类型是链接时跳转链接
        if (item.banner_type === '链接' && item.link_content) {
          window_open(item.link_content)
        }
      },
      h5swiper_change(e) { //h5轮播切换
        if (e !== this.tabbar_idx) {
          this.tabbar_idx = e
        }
      },
      //点击切换下一个
      click_next() { //轮播图点击切换下一个
        this.swiper.slideNext();
      },
      //获取产品标签
      get_tags(obj) {
        let str = '';
        if (this.GET_LANG2 === 'cn') {
          str = obj.keyWordCn;
        } else if (this.GET_LANG2 === 'en') {
          str = obj.keyWordEn;
        } else if (this.GET_LANG2 === 'jp') {
          str = obj.keyWordJp;
        }
        if (str) {
          return str.split(',');
        } else {
          return [];
        }
      },
      //获取产品名称
      get_productName(obj) {
        switch (this.GET_LANG2) {
          case 'cn':
            return obj.productNameCn;
          case 'en':
            return obj.productNameEn;
          case 'jp':
            return obj.productNameJp;
        }
      },
      //点击右侧的选项卡
      click_tabbar(idx, banner_id) {
        this.tabbar_idx = idx;
        if (this.type === 'pc') {
          this.swiper.slideTo(this.tabbar_idx, 1000, false);
        } else {
          this.$refs.swiper_h5.swipeTo(this.tabbar_idx)
        }
      },
      //获取右侧的选项卡名字
      get_tabbarname(item) {
        if (item.banner_type === '主线产品') {
          return this.get_productName(item.productorInfoModel);
        } else if (item.banner_type === '周边产品') {
          return this.get_productName(item.productorPreInfoModel);
        } else if (item.banner_type === '链接') {
          return item.link_title;
        }
      },
      //device设备，lang语言
      shuju_shaixuan(arr, device, lang) {
        let newarr = [...arr];
        let newlang = '';
        if (lang === 'zh') {
          newlang = 'CN';
        } else if (lang === 'en') {
          newlang = 'EN';
        } else if (lang === 'ja') {
          newlang = 'JPN';
        }
        if (arr.length === 0) {
          return [];
        }
        return newarr.filter(item => item.device === device && item.lang_type === newlang);
      },

    }
  };
</script>

<style scoped="scoped">
  .van-swipe {
    height: 100vh;
    overflow: hidden;
  }

  .swiper_group {
    min-height: 56.25vw;
  }

  .home_shubiao {
    position: absolute;
    left: 50%;
    bottom: 30px;
    width: 102px;
    height: 102px;
    z-index: 99;
    padding: 30px;
    transform: translateX(-50%);
    animation: next 1.5s linear 0s infinite;
  }

  @-ms-keyframes next {

    0% {
      transform: translate(-50%);
      -o-transform: translate(-50%);
      -ms-transform: translate(-50%);
      -moz-transform: translate(-50%);
    }

    50% {
      transform: translate(-50%, 0.1rem);
      -o-transform: translate(-50%, 0.1rem);
      -ms-transform: translate(-50%, 0.1rem);
      -moz-transform: translate(-50%, 0.1rem);
    }

    100% {
      transform: translate(-50%);
      -o-transform: translate(-50%);
      -ms-transform: translate(-50%);
      -moz-transform: translate(-50%);
    }

  }

  @keyframes next {
    0% {
      transform: translate(-50%);
      -o-transform: translate(-50%);
      -ms-transform: translate(-50%);
      -moz-transform: translate(-50%);
    }

    50% {
      transform: translate(-50%, 0.1rem);
      -o-transform: translate(-50%, 0.1rem);
      -ms-transform: translate(-50%, 0.1rem);
      -moz-transform: translate(-50%, 0.1rem);
    }

    100% {
      transform: translate(-50%);
      -o-transform: translate(-50%);
      -ms-transform: translate(-50%);
      -moz-transform: translate(-50%);
    }
  }

  .swiper_content {
    width: 100vw;
    max-height: 100vh;
    /* height: 56.25vw; */
    height: 100%;
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
  }

  .content_right {
    position: fixed;
    top: 50vh;
    right: 0px;
    transform: translateY(-50%);
    padding-right: 120px;
    z-index: 99;
  }

  .swiper_content_h5 {
    width: 100%;
    height: 100vh;
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
  }

  .swiper_img_h5 {
    width: 100%;
  }

  /* tabbar */
  .content_right_item {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 800;
    padding: 25px 0;
    transition-property: color, fontSize;
    transition: 500ms;
  }

  .check_style {
    color: #fff;
    font-size: 24px;
  }

  .content_right_dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.5);
    margin-left: 10px;
    transition-property: background-color, width;
    transition: all 500ms;
  }

  .check_dot {
    background-color: #fff;
    width: 30px;
  }

  /* h5 */
  .content_right_h5 {
    position: fixed;
    top: 50vh;
    right: 0px;
    transform: translateY(-50%);
    padding-right: 27px;
    z-index: 99;
  }

  .content_right_item_h5 {
    font-size: 9px;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 800;
    padding: 10px 0;
    transition-property: color, fontSize;
    transition: 500ms;
  }

  .check_style_h5 {
    color: #fff;
    font-size: 12px;
  }

  .content_right_dot_h5 {
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.5);
    margin-left: 10px;
    transition-property: background-color, width;
    transition: all 500ms;
  }

  .check_dot_h5 {
    background-color: #fff;
    width: 18px;
  }

  /*  */
  .tabbar_content {
    position: absolute;
    top: 50vh;
    left: 0;
    transform: translateY(-50%);
    margin-left: 120px;
    width: 920px;
  }

  .tabbar_content_name {
    display: inline-block;
    position: relative;
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .p_diamond {
    display: inline-block;
    min-width: 58px;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    margin-left: 10px;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    transform: skew(-20deg);
    text-align: center;
    font-size: 14px;
    color: #fff;
    font-weight: 800;
    position: relative;
    top: -40px;
  }

  .goods_tags {
    width: 100%;
    min-height: 20px;
  }

  .goods_tags_item {
    padding: 7px 15px;
    min-width: 20px;
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.3);
    margin: 0 30px 30px 0;
  }

  .a_biao:hover {
    color: #fff;
  }

  .a_biao {
    color: #fff;
  }

  .btn_item {
    display: inline-block;
    min-width: 200px;
    height: 60px;
    line-height: 60px;
    border-radius: 6px 6px 6px 6px;
    padding: 0 20px;
    margin: 30px 60px 0 0px;
    text-decoration: none !important;
  }

  /* h5 */
  .tabbar_content_h5 {
    position: absolute;
    bottom: 60px;
    width: 100vw;
  }

  .p_diamond_h5 {
    display: inline-block;
    min-width: 58px;
    padding: 0 5px;
    height: 25px;
    line-height: 25px;
    border-radius: 4px;
    margin-left: 10px;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    transform: skew(-20deg);
    text-align: center;
    color: #fff;
    font-weight: 800;
  }

  .goods_tags_h5 {}

  .goods_tags_item_h5 {
    padding: 4px 10px;
    min-width: 20px;
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.3);
    margin: 0px 7.5px 15px 7.5px;
  }

  .btn_item_h5 {
    display: inline-block;
    min-width: 102px;
    height: 36px;
    line-height: 36px;
    border-radius: 6px 6px 6px 6px;
    padding: 0 20px;
    margin: 15px 5px 0 5px;
    text-decoration: none !important;
  }
</style>

<style>
  .swiper-container {
    position: relative;
    width: 100%;
    height: 100vh;
  }

  .swiper-slide {
    /* height: 100vh; */
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-vueSwiper/public-vueSwiper.vue